import {ServiceBase} from "../ServiceBase";
import {ITippingHistoryService} from "./tipping-history.service.interface";
import {ITippingHistoryViewModel} from "./models/tipping-history-view-model.interface";
import {TippingHistoryBaseModel} from "./models/tipping-history-view-model";

export class TippingHistoryService extends ServiceBase implements ITippingHistoryService {
    getTippingHistory(): ITippingHistoryViewModel {
        return new TippingHistoryBaseModel(this.services);
    }
}
